import { Module } from '../utils/_application'
import Swiper from '../utils/_swiper'

const $ = jQuery

export default class ProductsSlider extends Module {
  ready (app) {
    this.productsSliders = document.querySelectorAll('.mtt-products-slider')

    if (this.productsSliders.length) {
      for (let i = 0; i < this.productsSliders.length; i++) {
        const sliderWrapper = this.productsSliders[i]

        new ProductSlider(sliderWrapper)
      }
    }
  }
}

class ProductSlider {
  constructor (sliderWrapper) {
    this.sliderWrapper = sliderWrapper
    this.addSlider()
  }

  addSlider () {
    this.slider = this.sliderWrapper.querySelector('.swiper-container')

    const nextArrow = this.sliderWrapper.querySelector('.mtt-swiper-button-next')
    const prevArrow = this.sliderWrapper.querySelector('.mtt-swiper-button-prev')

    new Swiper(this.slider, {
      slidesPerView: 1,
      spaceBetween: 24,
      watchOverflow: true,
      watchSlidesProgress: true,
      navigation: {
        nextEl: nextArrow,
        prevEl: prevArrow
      },
      breakpoints: {
        580: {
          slidesPerView: 2
        },
        900: {
          slidesPerView: 3
        }
      }
    })
  }
}
